module.exports = __webpack_public_path__ + "img/06.7f8f3318.png";